import React from 'react';
import { useProjectPresence } from '../../hooks/useProjectPresence';

interface SubHeaderPresenceProps {
  projectId?: string;
}

export const SubHeaderPresence: React.FC<SubHeaderPresenceProps> = ({ projectId }) => {
  const activePresenceUsers = useProjectPresence(projectId);

  if (activePresenceUsers.length === 0) return null;

  return (
    <div 
      className="flex items-center -space-x-2 overflow-hidden px-2 py-1 bg-slate-100 dark:bg-slate-800/80 rounded-xl border border-slate-200/50 dark:border-slate-800 shadow-sm" 
      title={`${activePresenceUsers.length} aktive(r) Nutzer in diesem Projekt`}
    >
      <span className="relative flex h-2 w-2 mr-2 ml-1">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
      </span>
      {activePresenceUsers.slice(0, 4).map(u => (
        <div 
          key={u.uid} 
          className={`w-6 h-6 rounded-full ${u.color} text-white font-black text-[9px] flex items-center justify-center ring-2 ring-white dark:ring-slate-900 shadow-sm shrink-0`}
          title={`${u.name} (${u.email}) - Aktive Live-Sitzung`}
        >
          {u.initials}
        </div>
      ))}
      {activePresenceUsers.length > 4 && (
        <div className="w-6 h-6 rounded-full bg-slate-400 text-white font-bold text-[9px] flex items-center justify-center ring-2 ring-white dark:ring-slate-900 shrink-0">
          +{activePresenceUsers.length - 4}
        </div>
      )}
    </div>
  );
};
